/**
 * Generate page numbers with ellipsis for large page counts.
 * Always shows first page, last page, and a window of ±1 around the current page.
 *
 * Example: generatePaginationPages(5, 20) => [1, 'ellipsis', 4, 5, 6, 'ellipsis', 20]
 */
export function generatePaginationPages(
    currentPage: number,
    totalPages: number
): (number | 'ellipsis')[] {
    return Array.from({ length: totalPages }, (_, i) => i + 1)
        .filter(p => {
            if (p === 1 || p === totalPages) return true;
            if (Math.abs(p - currentPage) <= 1) return true;
            return false;
        })
        .reduce((acc: (number | 'ellipsis')[], p, i, arr) => {
            if (i > 0 && typeof arr[i - 1] === 'number' && p - (arr[i - 1] as number) > 1) {
                acc.push('ellipsis');
            }
            acc.push(p);
            return acc;
        }, []);
}
